import { useFragmentFromStore } from '@smx-ui-model/hooks/use-fragment-from-store';
import { getModel } from '@smx-ui-model/store-model';
import { GenericModelSchemaType, StoreModelType } from '@smx-ui-model/types';
import { Form } from 'antd';
import * as React from 'react';
import { memo, useContext, useEffect } from 'react';

import { SmxInspectorContext } from './inspector-provider';

interface LoaderParentDataFormInspectorProps {
    parentModelName?: keyof StoreModelType;
}

const LoaderParentDataFormInspector: React.FC<LoaderParentDataFormInspectorProps> = ({ parentModelName }) => {
    const form = Form.useFormInstance();
    const { parentNode, parentData } = useContext(SmxInspectorContext);

    const dataParentEntity = (useFragmentFromStore(parentNode) || parentData) as any;

    const parentModel = parentModelName ? getModel<GenericModelSchemaType>(parentModelName) : null;

    useEffect(() => {
        console.log('_+_+_+_+_+_', parentData);
        const newData: any = !parentModel ? dataParentEntity : {};

        if (parentModel) {
            Object.keys(parentModel.fieldForChild!).forEach((fieldName) => {
                const childFieldName = (parentModel.fieldForChild as any)[fieldName];
                newData[childFieldName] = dataParentEntity[fieldName];
            });
        }

        form.setFieldsValue({
            ...newData,
        });
    }, [dataParentEntity]);

    return <></>;
};

export default memo(LoaderParentDataFormInspector);
